<template>
  <div class="home">
    <Header />
    <Providers />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "./Common/Header.vue";
import Providers from "@/components/Providers.vue";

export default {
  name: "providers",
  components: {
    Header,
    Providers
  }
};
</script>
